import { Tooltip, TooltipContent, TooltipTrigger } from "@/app/ui/imported/tooltip";
import Image from "@/app/ui/utils/Image";
import MiniIcon from "./MiniIcon";

function SocialImage({ src, text, size = 50, unit = "px" }: { src: string, text: string, size?: number, unit?: "px" | "em" | "rem" | "vmin" }) {
    let parsedSize = size;
    if (unit == "em")
        parsedSize *= 20;

    return <Tooltip>
        <TooltipTrigger asChild>
            <div className="relative w-min">
                <Image src={ src } alt={ text } width={ parsedSize } height={ parsedSize }
                    className="rounded-full max-w-[initial] peer aspect-square bg-nfPurple-400"
                    style={ { width: `${size}${unit}` } } />
                <MiniIcon offset={ "-0.3em" } type={ src.includes("discord") ? "discord" : "youtube" } size={ `${size / 3.5}${unit}` } />
            </div>

        </TooltipTrigger>
        <TooltipContent>
            <p className="whitespace-pre-line">{ text }</p>
        </TooltipContent>
    </Tooltip>
}
export default SocialImage